import type { IconSvgObject } from './types';

const ProtectionMaskIcon: IconSvgObject = [
  ["path", { d: "M15.0686 14.8454L20.0256 11.5L22 15L19.7002 20.3611C19.2737 21.3554 18.2951 22 17.2123 22C16.7425 22 16.2812 21.8828 15.8838 21.6324C12.0423 19.2126 5.40202 13.1147 7.3503 10.4879C8.12684 9.44098 10.112 9.73499 15.0686 14.8454ZM15.0686 14.8454L14.0021 20.0793", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M20 9C19.0905 4.99202 15.2832 2 11 2C6.02944 2 2 6.02944 2 11C2 13.0172 2.66363 15.1829 3.78448 16.7194C3.91943 16.9044 4 17.1249 4 17.3539V22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ProtectionMaskIcon;
